import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer className="border-t border-edge bg-void">
    <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
      <div className="grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="font-head text-2xl font-bold uppercase tracking-tighter">
            <span className="text-gray-100">GRADE</span><span className="text-yellow">TRACK</span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-gray-400">
            Construction field mapping &amp; plan visualization. Put the plans on the ground.
          </p>
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-gray-600">
            A sister product to CrewTrack.
          </p>
        </div>

        <div>
          <h4 className="font-mono text-xs font-semibold uppercase tracking-widest text-gray-500">Product</h4>
          <ul className="mt-5 space-y-3 text-sm text-gray-300">
            <li><Link to="/app" className="hover:text-yellow">Map</Link></li>
            <li><Link to="/app?panel=plans" className="hover:text-yellow">Plans</Link></li>
            <li><Link to="/app?panel=tracking" className="hover:text-yellow">Tracking</Link></li>
            <li><Link to="/mounts" className="hover:text-yellow">Mounts</Link></li>
            <li><Link to="/about" className="hover:text-yellow">About Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs font-semibold uppercase tracking-widest text-gray-500">Legal</h4>
          <ul className="mt-5 space-y-3 text-sm text-gray-300">
            <li><a href="#" className="hover:text-yellow">Privacy</a></li>
            <li><a href="#" className="hover:text-yellow">Terms</a></li>
            <li><a href="#" className="hover:text-yellow">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-mono text-xs font-semibold uppercase tracking-widest text-gray-500">Sister Software</h4>
          <div className="mt-5 border border-edge bg-cardbg p-5">
            <div className="font-head text-xl font-bold uppercase tracking-tight">
              <span className="text-gray-100">CREW</span><span className="text-crew">TRACK</span>
            </div>
            <p className="mt-2 text-sm text-gray-400">
              Construction field software for crews, equipment, time, labor &amp; production.
            </p>
            <a href="https://crewtrack.team" target="_blank" rel="noopener noreferrer"
              data-testid="footer-crewtrack-link"
              className="mt-4 inline-flex items-center gap-1 font-mono text-xs font-bold uppercase tracking-widest text-crew hover:underline">
              Visit CrewTrack <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-edgesubtle pt-6 md:flex-row md:items-center">
        <p className="font-mono text-xs uppercase tracking-widest text-gray-600">
          © {new Date().getFullYear()} GradeTrack — Built from the field.
        </p>
        <p className="font-mono text-xs uppercase tracking-widest text-gray-600">
          Phone GPS is approximate. Not survey-grade positioning.
        </p>
      </div>
    </div>
  </footer>
);
